import { render, staticRenderFns } from "./organize.vue?vue&type=template&id=2d45e04d&scoped=true&"
import script from "./organize.vue?vue&type=script&lang=js&"
export * from "./organize.vue?vue&type=script&lang=js&"
import style0 from "./organize.vue?vue&type=style&index=0&id=2d45e04d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45e04d",
  null
  
)

export default component.exports